import { action } from 'easy-peasy'

export const chimeModel = {
  chime: {
    meetingStatus: undefined,
    audioLevel: 0,
    hasDetectedAudio: false,
    showMicWarning: false,
    audioLastDetectedAt: null,
    setAudioLastDetectedAt: action((state, val) => {
      state.audioLastDetectedAt = val
    }),
    setShowMicWarning: action((state, bool) => {
      state.showMicWarning = bool
    }),
    setAudioLevel: action((state, audioLevel) => {
      state.audioLevel = audioLevel
    }),
    setHasDetectedAudio: action((state, bool) => {
      state.hasDetectedAudio = bool
    }),
    setMeetingStatus: action((state, meetingStatus) => {
      state.meetingStatus = meetingStatus
    })
  }
}
